import { Spinner } from '@nextui-org/react';
import cn from '@/helpers/cn';

interface SpinnerOverlayProps {
  sceneLevel?: boolean;
  visible?: boolean;
}

export function SpinnerOverlay({ sceneLevel, visible }: SpinnerOverlayProps) {
  return visible ? (
    <div
      className={cn(
        'w-screen h-screen flex flex-col justify-center items-center',
        sceneLevel && 'before:bg-default-200'
      )}
    >
      <Spinner size="lg" />
    </div>
  ) : (
    <></>
  );
}
